
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 32 32","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M8.1 8v8.1H7c-.7 0-1.3-.6-1.3-1.3V9.4C5.7 8.6 6.3 8 7 8h1.1m1.5-1.5H7c-1.6 0-2.8 1.3-2.8 2.8v5.4c0 1.6 1.3 2.8 2.8 2.8h2.6v-11zM11.1 20.4l2.2 8.1H12l-2.2-8.1h1.3m.8-1.5h-4L11 30h4.4l-3.1-11.1h-.4zM23.5 5.1v14c-2.2-1.4-5.6-2.7-10.4-2.9h-.7V8c5.2-.1 8.8-1.5 11.1-2.9M25 2c-1.8 1.8-5.7 4.5-13.1 4.5h-1v11.1H13c6.7.2 10.4 2.8 12.1 4.5V2H25zM26.3 8.9v6.3c.9-.8 1.5-1.9 1.5-3.2 0-1.2-.6-2.3-1.5-3.1z"}})])
          )
        }
      }
    